export default __webpack_public_path__ + "static/media/video-sdg-15.756849f0.mp4";